import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { PropTypes } from 'prop-types';
import moment from 'moment';

import { DownOutlined, UpOutlined } from '@ant-design/icons';

import { Table, Button } from 'antd';

import LoadList01Actions from '../../Stores/LoadList01/Actions';

class OutbOrdTable extends React.PureComponent {
  constructor() {
    super();

    this.state = { pageSize: 20 };

    this.getDocumentColumns = this.getDocumentColumns.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate() {}

  componentWillUnmount() {}

  getDocumentColumns() {
    const { intl, upOutbOrd, downOutbOrd, outbOrdHdrs } = this.props;

    return [
      {
        width: 50,
        // fixed: 'left',
        key: 'action',
        render: (text, record) => (
          <>
            <Button
              type="dashed"
              icon={<UpOutlined />}
              size="small"
              onClick={() => upOutbOrd(record)}
            />
            <Button
              type="dashed"
              icon={<DownOutlined />}
              size="small"
              onClick={() => downOutbOrd(record)}
            />
          </>
        )
      },
      {
        // fixed: 'left',
        width: 50,
        align: 'right',
        title: '#',
        key: 'line_no',
        render: (text, record) => (
          <span style={{ wordBreak: 'normal' }}>{outbOrdHdrs.indexOf(record) + 1}</span>
        )
      },
      {
        width: 120,
        align: 'left',
        title: intl.formatMessage({ id: 'shipping_doc_code' }),
        // sort field
        dataIndex: 'shipping_doc_code',
        // filter field
        key: 'shipping_doc_code',
        render: (text, record) => record.shipping_doc_code
      },
      {
        width: 120,
        align: 'left',
        title: intl.formatMessage({ id: 'ref_code_01' }),
        // sort field
        dataIndex: 'ref_code_01',
        // filter field
        key: 'ref_code_01',
        render: (text, record) => record.ref_code_01
      },
      {
        width: 105,
        align: 'left',
        title: intl.formatMessage({ id: 'doc_date' }),
        // sort field
        dataIndex: 'doc_date',
        // filter field
        key: 'doc_date',
        render: (text, record) => <>{moment(record.doc_date).format('YYYY-MM-DD')}</>
      },
      {
        width: 100,
        // fixed: 'right',
        align: 'right',
        title: intl.formatMessage({ id: 'net_amt' }),
        // sort field
        dataIndex: 'net_amt',
        // filter field
        key: 'net_amt',
        render: (text, record) => (
          <>
            {new Intl.NumberFormat([], {
              style: 'decimal',
              minimumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE,
              maximumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE
            }).format(record.net_amt)}
          </>
        )
      },
      {
        width: 100,
        // fixed: 'right',
        align: 'right',
        title: intl.formatMessage({ id: 'case_decimal_qty' }),
        // sort field
        dataIndex: 'case_decimal_qty',
        // filter field
        key: 'case_decimal_qty',
        render: (text, record) => (
          <>
            {new Intl.NumberFormat([], {
              style: 'decimal',
              minimumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE,
              maximumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE
            }).format(record.case_decimal_qty)}
          </>
        )
      },
      {
        width: 100,
        // fixed: 'right',
        align: 'right',
        title: intl.formatMessage({ id: 'gross_weight' }),
        // sort field
        dataIndex: 'gross_weight',
        // filter field
        key: 'gross_weight',
        render: (text, record) => (
          <>
            {new Intl.NumberFormat([], {
              style: 'decimal',
              minimumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE,
              maximumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE
            }).format(record.gross_weight)}
          </>
        )
      },
      {
        width: 100,
        // fixed: 'right',
        align: 'right',
        title: intl.formatMessage({ id: 'cubic_meter' }),
        // sort field
        dataIndex: 'cubic_meter',
        // filter field
        key: 'cubic_meter',
        render: (text, record) => (
          <>
            {new Intl.NumberFormat([], {
              style: 'decimal',
              minimumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE,
              maximumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE
            }).format(record.cubic_meter)}
          </>
        )
      },
      {
        width: 120,
        align: 'left',
        title: intl.formatMessage({ id: 'division' }),
        // sort field
        dataIndex: 'division_code',
        // filter field
        key: 'division',
        render: (text, record) => <>{record.division_code}</>
      },
      {
        width: 100,
        align: 'left',
        title: intl.formatMessage({ id: 'area' }),
        // sort field
        dataIndex: 'delivery_point_area_code',
        // filter field
        key: 'delivery_point_area',
        render: (text, record) => (
          <>
            <b>{record.delivery_point_area_code}</b>
            <br />
            {record.delivery_point_area_desc_01}
          </>
        )
      },
      {
        width: 150,
        align: 'left',
        title: intl.formatMessage({ id: 'delivery_point' }),
        // sort field
        dataIndex: 'delivery_point_code',
        // filter field
        key: 'delivery_point',
        render: (text, record) => (
          <>
            <b>{record.delivery_point_code}</b>
            <br />
            {record.delivery_point_company_name_01}
          </>
        )
      },
      {
        width: 120,
        align: 'left',
        title: intl.formatMessage({ id: 'salesman' }),
        // sort field
        dataIndex: 'salesman_username',
        // filter field
        key: 'salesman',
        render: (text, record) => (
          <>
            <b>{record.salesman_username}</b>
          </>
        )
      }
    ];
  }

  render() {
    const { intl, outbOrdHdrs, fetchIsLoading } = this.props;
    const { pageSize: statePageSize } = this.state;

    return (
      <Table
        title={() => intl.formatMessage({ id: 'outbound_orders' })}
        // rowSelection={rowSelection}
        rowKey="id"
        pagination={{
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
          showSizeChanger: true,
          pageSizeOptions: ['20', '50'],
          onShowSizeChange: (current, pageSize) => {
            this.setState({
              pageSize
            });
          },
          pageSize: statePageSize
        }}
        columns={this.getDocumentColumns()}
        dataSource={outbOrdHdrs}
        loading={fetchIsLoading}
        bordered
        scroll={{ x: 950 }}
        summary={pageData => {
          // summarise the table
          const calcRow = pageData.reduce(
            (ttlObj, object) => {
              return {
                net_amt: ('net_amt' in ttlObj ? ttlObj.net_amt : 0) + parseFloat(object.net_amt),
                case_decimal_qty:
                  ('case_decimal_qty' in ttlObj ? ttlObj.case_decimal_qty : 0) +
                  parseFloat(object.case_decimal_qty),
                gross_weight:
                  ('gross_weight' in ttlObj ? ttlObj.gross_weight : 0) +
                  parseFloat(object.gross_weight),
                cubic_meter:
                  ('cubic_meter' in ttlObj ? ttlObj.cubic_meter : 0) +
                  parseFloat(object.cubic_meter)
              };
            },
            { net_amt: 0, case_decimal_qty: 0, gross_weight: 0, cubic_meter: 0 }
          );

          return (
            <>
              <tr className="ant-table-row">
                <td style={{ textAlign: 'right', fontWeight: 'bold' }} colSpan={5}>
                  {intl.formatMessage({ id: 'total' })}
                </td>
                <td style={{ textAlign: 'right', fontWeight: 'bold' }}>
                  {new Intl.NumberFormat([], {
                    style: 'decimal',
                    minimumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE,
                    maximumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE
                  }).format(calcRow.net_amt)}
                </td>
                <td style={{ textAlign: 'right', fontWeight: 'bold' }}>
                  {new Intl.NumberFormat([], {
                    style: 'decimal',
                    minimumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE,
                    maximumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE
                  }).format(calcRow.case_decimal_qty)}
                </td>
                <td style={{ textAlign: 'right', fontWeight: 'bold' }}>
                  {new Intl.NumberFormat([], {
                    style: 'decimal',
                    minimumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE,
                    maximumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE
                  }).format(calcRow.gross_weight)}
                </td>
                <td style={{ textAlign: 'right', fontWeight: 'bold' }}>
                  {new Intl.NumberFormat([], {
                    style: 'decimal',
                    minimumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE,
                    maximumFractionDigits: process.env.REACT_APP_DECIMAL_SCALE
                  }).format(calcRow.cubic_meter)}
                </td>
              </tr>
            </>
          );
        }}
      />
    );
  }
}

OutbOrdTable.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  outbOrdHdrs: PropTypes.arrayOf(PropTypes.object),
  fetchIsLoading: PropTypes.bool,

  upOutbOrd: PropTypes.func,
  downOutbOrd: PropTypes.func
};

OutbOrdTable.defaultProps = {
  intl: {},

  outbOrdHdrs: [],

  fetchIsLoading: false,

  upOutbOrd() {},
  downOutbOrd() {}
};

const mapStateToProps = state => ({
  timestamp: state.loadList01.outbOrdTimestamp,

  outbOrdHdrs: state.loadList01.outbOrdHdrs,

  fetchIsLoading: state.loadList01.fetchIsLoading
});

const mapDispatchToProps = dispatch => ({
  resetTimestamp: (currentPage, sorts, filters, pageSize) =>
    dispatch(LoadList01Actions.outbOrdIndexResetTimestamp(currentPage, sorts, filters, pageSize)),

  upOutbOrd: outbOrdHdr => dispatch(LoadList01Actions.loadList01UpOutbOrd(outbOrdHdr)),
  downOutbOrd: outbOrdHdr => dispatch(LoadList01Actions.loadList01DownOutbOrd(outbOrdHdr))
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(OutbOrdTable));
